import { useEffect } from "react";

export const useChangeDocumentTitle = (pageTitle) => {
  useEffect(() => {
    document.title = `Jonathan Nolen - ${pageTitle}`;
  }, [pageTitle]);
};
